import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Reviews from "@/pages/Reviews";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthProvider";
import AuthCallback from "@/auth/AuthCallback";
import ProtectedRoute from "@/auth/ProtectedRoute";
import CookieBanner from "@/components/sad/CookieBanner";
import { initAnalyticsFromStoredConsent } from "@/lib/analytics";

function AppRouter() {
  const location = useLocation();

  // Synchronous detection of OAuth callback (must happen before normal routing)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/confidentialite" element={<PrivacyPolicy />} />
      <Route path="/avis" element={<Reviews />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = "SAD — Solutions Agencement Décoration | Île de la Réunion";
    // Defensive: clear any leftover URL hash so Chrome doesn't snap back to a
    // previously visited section when interactive elements (selects, buttons)
    // gain focus.
    if (window.history?.replaceState && window.location.hash && !window.location.hash.includes("session_id=")) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
    // Replay stored consent (Meta Pixel + Consent Mode update) if user already chose
    initAnalyticsFromStoredConsent();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
